// extracted by mini-css-extract-plugin
export var cardLayout = "_2c-1";
export var paginationContainer = "_2c-0";